import { render, staticRenderFns } from "./WidgetMetaAtualVendedor.vue?vue&type=template&id=237525e2&scoped=true"
import script from "./WidgetMetaAtualVendedor.vue?vue&type=script&lang=ts"
export * from "./WidgetMetaAtualVendedor.vue?vue&type=script&lang=ts"
import style0 from "./WidgetMetaAtualVendedor.vue?vue&type=style&index=0&id=237525e2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237525e2",
  null
  
)

export default component.exports